@layer module {
.side-panel__head {
            display: flex;
            align-items: center;
            justify-content: space-between;
    }

.side-panel__heading {
            display: flex;
            align-items: center;
            min-width: 0;
    }

.side-panel__titles {
            min-width: 0;
    }

.side-panel__icon {
            display: grid;
            flex-shrink: 0;
            place-items: center;
    }

.side-panel__close {
            display: grid;
            flex-shrink: 0;
            place-items: center;
            border: none;
            cursor: pointer;
    }

.side-panel__body {
            display: flex;
            flex: 1 1 auto;
            flex-direction: column;
            min-height: 0;
            overflow-y: auto;
    }

.side-panel__section {
            display: flex;
            flex-direction: column;
            flex-shrink: 0;
    }

.side-panel__section-head {
            display: flex;
            align-items: baseline;
            justify-content: space-between;
    }

.side-panel__row {
            display: flex;
            align-items: flex-start;
            border-bottom: 1px solid;
    }

.side-panel__label {
            flex-shrink: 0;
    }

.side-panel__value {
            display: flex;
            flex-grow: 1;
            align-items: center;
            min-width: 0;
            word-break: break-word;
    }

.side-panel__copy {
            display: grid;
            flex-shrink: 0;
            place-items: center;
            border: none;
            cursor: pointer;
    }

.side-panel__actions {
            display: flex;
            flex-wrap: wrap;
    }
} // layer module










@layer app {
.side-panel__head {
            gap: $size-12;
            padding: $size-14 $size-16 $size-6 $size-18;
    }

.side-panel__heading {
            gap: $size-12;
    }

.side-panel__icon {
            width: $size-38;
            height: $size-38;
            border-radius: 50%;
    }

.side-panel__close {
            width: $size-30;
            height: $size-30;
            padding: 0;
            border-radius: 50%;
    }

.side-panel__body {
            gap: $size-18;
            padding: $size-6 $size-18 $size-18;
    }

.side-panel__section-head {
            gap: $size-10;
            margin-bottom: $size-4;
    }

.side-panel__row {
            gap: $size-10;
            padding: $size-10 0;
    }

.side-panel__label {
            width: $size-116;
    }

.side-panel__value {
            gap: $size-6;
    }

.side-panel__copy {
            width: $size-26;
            height: $size-26;
            margin-top: $size-neg-3;
            padding: 0;
            border-radius: $size-7;
    }

.side-panel__copy svg {
            width: $size-13;
            height: $size-13;
    }

.side-panel__actions {
            gap: $size-8;
    }

.side-panel__icon {
            background: var(--color-brand-tint);
            color: var(--color-brand);
    }

.side-panel__eyebrow {
            color: var(--text-secondary);
            font-size: var(--font-size-sm);
    }

.side-panel__title {
            color: var(--text-primary);
            font-size: var(--font-size-lg);
            font-weight: 600;
            line-height: 1.35;
    }

.side-panel__close {
            background: var(--bg-neutral-chip);
            color: var(--text-body);
    }

.side-panel__section-title {
            color: var(--text-primary);
            font-size: var(--font-size-base);
            font-weight: 500;
    }

.side-panel__section-aside {
            color: var(--text-secondary);
            font-size: var(--font-size-sm);
    }

.side-panel__row {
            border-bottom-color: var(--border-light);
    }

.side-panel__label {
            color: var(--text-secondary);
            font-size: var(--font-size-sm);
    }

.side-panel__value {
            color: var(--text-primary);
            font-size: var(--font-size-base);
            font-variant-numeric: tabular-nums;
            font-weight: 500;
    }

.side-panel__value--success {
            color: var(--color-success-text);
    }

.side-panel__value--error {
            color: var(--color-error-text);
    }

.side-panel__copy {
            background: transparent;
            color: var(--text-body);
    }

.side-panel__copy:hover {
            background: var(--page-canvas);
    }
} // layer app










@layer context {
      @media (min-width: 641px) {
                :global([data-row-details]) .side-panel__row {
                        justify-content: space-between;
                    }

                :global([data-row-details]) .side-panel__value {
                        justify-content: flex-end;
                        text-align: right;
                    }
          }

      @media (max-width: 640px) {
                :global([data-row-details]) .side-panel__row {
                        flex-wrap: wrap;
                        gap: 2px $size-10;
                    }

                :global([data-row-details]) .side-panel__label {
                        width: 100%;
                    }
          }
} // layer context
